import { Thumbnail } from '@vimily/bonjoro-ui-components-v2/VideoRecorder';
import axios from 'axios';

type ThumbType = keyof Omit<Thumbnail, 'time' | 'hash'>;

export const createThumbnailBlob = async (
  thumbnail?: Thumbnail,
  thumbType: ThumbType = 'square'
) => {
  const thumbnailData = thumbnail?.[thumbType].data;

  if (thumbnailData) {
    const res = await axios.get<Blob>(thumbnailData, {
      responseType: 'blob',
    });
    return res.data;
  }

  return null;
};
